import { render, staticRenderFns } from "./leftPerson.vue?vue&type=template&id=2be299a8&scoped=true&"
import script from "./leftPerson.vue?vue&type=script&lang=js&"
export * from "./leftPerson.vue?vue&type=script&lang=js&"
import style0 from "./leftPerson.vue?vue&type=style&index=0&id=2be299a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be299a8",
  null
  
)

export default component.exports